<template>
  <div class="upload-container">
    <!-- 从pcb解析中 -->
    <div v-if="+pcbFileAnalyzeStatus === 2" class="buy_bom__upload__analyzing">
      <img src="~@@/assets/img/common/file-loading.png" class="buy_bom__upload__analyzing__img" />
      <span class="buy_bom__upload__analyzing__text">正在从PCB源文件解析{{ fileType == 0 ? 'BOM' : '坐标文件' }}数据...</span>
    </div>
    <!-- 从pcb解析失败 1、pcb解析失败了 2 解析成功了但是 没有url地址 -->
    <div v-if="(+pcbFileAnalyzeStatus === 5 || (pcbFileAnalyzeStatus == 4 && !autoAnalyzeFile)) && showAnalyzeError" class="buy_bom__upload__analyz__error">
      <img src="~@@/assets/img/common/error-img.png" class="buy_bom__upload__analyz__error__icon" />
      <span class="buy_bom__upload__analyz__error__text">从PCB源文件解析{{ fileType == 0 ? 'BOM' : '坐标文件' }}数据失败，请在下方手动上传</span>
      <img src="~@@/assets/img/common/close.png" class="buy_bom__upload__analyz__error__close" @click="handleCloseParseError" />
    </div>
    <!-- 从pcb解析成功  -->
    <div v-if="autoAnalyzeFile && firstAnalyze"  class="buy_bom__upload__analyz__success">
        <img src="~@@/assets/img/common/success-img.png" class="buy_bom__upload__analyz__success__img" />
        <span class="buy_bom__upload__analyz__success__label">解析成功：</span>
        <span class="buy_bom__upload__analyz__success__name">{{ autoAnalyzeFile | filterFileName }}</span>
        <span class="buy_bom__upload__analyz__success__view" @click="() =>handleViewParsedFile()">查看</span>
        <label class="custom-checkbox" @click="useAutoAnalyzeFile">
          <input type="checkbox" />
          <span class="custom-checkbox__box"></span>
          <span class="custom-checkbox__text">使用该文件</span>
        </label>
    </div>
    <!-- 切换类型 -->
    <div class="upload-mode-toggle" v-if="autoAnalyzeFile && !firstAnalyze">
      <span
        class="upload-mode-toggle__item"
        style="width: 100px;"
        :class="{ 'upload-mode-toggle__item--active': uploadMode === 'manual' }"
        @click="handleToggleMode('manual')"
      >手动上传</span>
      <span
        class="upload-mode-toggle__item"
        style="width: 230px"
        :class="{ 'upload-mode-toggle__item--active': uploadMode === 'parsed' }"
        @click="handleToggleMode('parsed')"
      >使用PCB源文件解析的{{ fileType == 0 ? 'BOM' : '坐标文件' }}数据</span>
    </div>
    <el-upload
      drag
      ref="uploadRef"
      name="file"
      class="upload"
      :class="['upload', `upload--${status}`, isSmtNotLogin ? 'upload--notLogin' : '']"
      :accept="accept"
      :action="url"
      :headers="{
        Authorization: authToken
      }"
      :data="{ type }"
      :show-text="false"
      :show-file-list="false"
      :disabled="isSmtNotLogin"
      :before-upload="handleBeforeUpload"
      :on-progress="handleOnProgress"
      :on-success="handleOnSuccess"
      :on-error="handleOnError"
      v-show="uploadMode == 'manual'"
    >
      <div 
        v-if="isSmtNotLogin" 
        class="upload--notLogin__modal" 
        @click.stop="handleShowLogin"
        @dragover.prevent.stop
        @dragenter.prevent.stop
        @drop.prevent.stop="handleShowLogin"
      ></div>
      <!-- 未开始 -->
      <div v-if="status === 0" class="upload__notStarted">
        <div class="notStarted-content">
          <img src="@@/assets/img/common/upload-img.png"/>
          <div class="notStarted-text">
            <div v-if="+pcbFileAnalyzeStatus===2">若不想等待，可 <span ref="uploadHandleRef" class="upload_handle">直接上传</span></div>
            <div v-else>拖拽文件到此，或 <span ref="uploadHandleRef" class="upload_handle">点击上传</span></div>
          </div>
        </div>
        <div class="tips-flex">
          <div class="tips-text">{{ tips }}</div>
          <a @click.stop="downloadTemplateUrl" class="tips-link"><img src="" class="tips-link-img"/>{{ fileType == 0 ? 'BOM模板下载' : '坐标文件模板下载' }}</a>
        </div>
      </div>
      <!-- 上传中 -->
      <div v-if="status === 1" class="upload__uploading" @click.stop>
        <p class="upload__uploading__name">
          {{ name }}
        </p>
        <div style="width: 200px">
          <el-progress
            color="#15A675"
            text-color="#FFFFFF"
            define-back-color="#EBECEF"
            :stroke-width="4"
            :text-inside="true"
            :percentage="upload.progress"
          ></el-progress>
        </div>
      </div>
      <!-- 上传成功 解析中 -->
      <div v-if="status === 2" class="upload__success" @click.stop>
        <p class="upload__success__name">
          {{ name }}
        </p>
        <p class="upload__success__text">
          上传成功，解析中
        </p>
        <el-progress
          color="#579DE2"
          text-color="#FFFFFF"
          define-back-color="#EBECEF"
          :stroke-width="18"
          :text-inside="true"
          :percentage="analyze.progress * 100"
          :format="val => `${Math.floor(val)}%`"
        ></el-progress>
      </div>
      <!-- 上传失败 -->
      <div v-if="status === 3" class="upload__fail" @click.stop>
        <div class="parsed-file-wrap">
          <div class="parsed-file-row parsed-file-row--fail">
            <div class="parsed-file-row__content">
              <span class="parsed-file-row__name">{{ name }}</span>
            </div>
          </div>
          <div class="parsed-file-row__btn" @click="handleClick">重新上传</div>
        </div>
        <!-- 这里 -->
        <div class="parse-error-banner">
          <img src="~@@/assets/img/common/error-img.png" class="parse-error-banner__icon" />
          <span class="parse-error-banner__text">{{ errorMsg || '上传失败，请重新上传！' }}</span>
        </div>
      </div>
      <!-- 解析成功4 修改回显 6 -->
      <div v-if="status === 4 || status === 6" class="upload__analyze-wrapper" @click.stop>
        <div class="parsed-file-wrap">
          <div class="parsed-file-row">
            <div class="parsed-file-row__content">
              <img src="~@@/assets/img/common/file-icon.png" class="parsed-file-row__icon" />
              <span class="parsed-file-row__name">{{ name }}</span>
              <span class="parsed-file-row__size">{{ formatSize }}</span>
              <span 
                v-if="type === 'bom' && +bomId && isShowBom"
                class="parsed-file-row__bom"
                @click="$refs.bomItemDialogRef.open(bomId)"
              >查看匹配详情</span>
            </div>
            <img src="~@@/assets/img/icons/icon_radio.png" class="parsed-file-row__corner" />
          </div>
          <div class="parsed-file-row__btn" @click="handleClick">重新上传</div>
        </div>
      </div>
      <!-- 解析失败 -->
      <div v-if="status === 5" class="upload__analyze__fail" @click.stop>
        <p class="upload__analyze__fail__text">解析失败</p>
        <BaseTextButton :plain="false" @click="handleClick">
          重新上传
        </BaseTextButton>
      </div>
      <!-- 修改回显 -->
    </el-upload>
    <!-- 使用解析文件 -->
    <div class="use-parsed-file-wrapper" v-if="uploadMode == 'parsed'">
      <div class="use-parsed-file-content">
        <div class="use-parsed-file-row">
          <div class="use-parsed-file-row__content">
            <img src="~@@/assets/img/common/file-icon.png" class="use-parsed-file-row__icon" />
            <span class="use-parsed-file-row__name">{{ fileName }}</span>
            <span class="use-parsed-file-row__tag">自动解析</span>
            <span class="use-parsed-file-row__download" @click="() =>handleViewParsedFile(true)">下载</span>
          </div>
          <img src="~@@/assets/img/icons/icon_radio.png" class="use-parsed-file-row__corner" />
        </div>
        <div class="use-parsed-file-row__btn" @click="handleClick">重新上传</div>
      </div>
    </div>
    <!-- PCB更新提示：新BOM已解析 -->
    <div v-if="autoAnalyzeFile && !firstAnalyze && showNewAnalyzeFile" class="file-updated-banner">
      <div class="file-updated-banner__left">
        <img src="~@@/assets/img/common/warning-icon.png" class="file-updated-banner__icon" />
        <span class="file-updated-banner__text">PCB更新，新{{ fileType == 0 ? 'BOM' : '坐标' }}已解析：{{ autoAnalyzeFile | filterFileName }}</span>
        <span class="file-updated-banner__download" @click="() => handleViewParsedFile()">下载</span>
      </div>
      <div class="file-updated-banner__right">
        <div class="file-updated-banner__btn" @click="useAutoAnalyzeFile">使用新{{ fileType == 0 ? 'BOM' : '坐标' }}数据</div>
        <img src="~@@/assets/img/common/close.png" class="file-updated-banner__close" @click="handleCloseFileUpdated" />
      </div>
    </div>
    <!-- BOM查看明细弹框 -->
    <BomItemDialog ref="bomItemDialogRef" />
  </div>
</template>

<script>
import CONFIG from '@@/config'
import { getToken } from '@@/utils/auth'
import { isSmtSite } from '@@/utils/is'
// import AnalyzeResult from './analyzeResult.vue'
// BOM查看明细弹框
import BomItemDialog from '@@/views/submit/components/bomItemDialog'

// 上传
const defaultUpload = {
  progress: 0, // 上传进度百分比
  timer: null, // 上传进度百分比定时器
}
// 解析
const defaultAnalyze = {
  analyzeing: false, //解析中
  progress: 0, // 解析进度百分比
  timer: null, // 解析进度百分比定时器
  analyzeTimer: null, // 解析接口定时器
  countdown: 60, // 解析倒计时
  countdownTimer: null, // 倒计时定时器
  timeConstant: 5000, // 进度条变化的快慢，数字越大，变化的越慢
}

export default {
  components: {
    BomItemDialog
  },
  props: {
    type: {
      type: String,
      default: 'bom'
    },
    fileUrl: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    fileType: {
      type: Number,
      default: 0
    },
    accept: {
      type: String,
      default: '.xls,.xlsx,.csv'
    },
    limitSize: {
      type: Number,
      default: 50
    },
    // 联动pcb文件的控件 状态： 0-未开始, 1-上传中, 2-上传成功, 3-上传失败, 4-解析成功, 5-解析失败, 6-修改回显
    pcbFileAnalyzeStatus: {
      type: Number,
      default: 0
    },
    tips: {
      type: String,
      default: '.xls、.xlsx、.csv格式 (50M以内)'
    },
    labelTips: {
      type: String,
      default: ''
    },
    // BOM选型id
    bomId: {
      type: [String, Number],
      default: ''
    },
    analyzeFile: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      authToken: getToken(),
      // 初始为 0
      status: 0, // 状态： 0-未开始, 1-上传中, 2-上传成功, 3-上传失败, 4-解析成功, 5-解析失败, 6-修改回显 
      name: '', // 文件名称
      size: 0, // 单位B
      analyze_id: '', // 上传成功后返回的id
      errorMsg: '', // 上传失败提示
      upload: { ...defaultUpload },
      analyze: { ...defaultAnalyze },
      // 缓存文件 上传文件 自动解析文件
      cacheFile: {
        uploadFile: {
          fileName: '',
          fileUrl: ''
        },
        autoAnalyzeFile: {
          fileName: '',
          fileUrl: ''
        }
      },
      autoAnalyzeFile: '', // 自动解析文件地址
      showNewAnalyzeFile: false, // 是否显示新解析文件
      showAnalyzeError: false, // 是否显示解析错误
      uploadMode: 'manual', // 上传模式 manual-手动上传 parsed-使用解析文件
      isShowBom: true, 
    }
  },
  computed: {
    url() {
      return `${CONFIG.HQPCBA_HOST}/pcba/app/file/fileUpload`
    },
    // 是否SMT站点且未登录
    isSmtNotLogin() {
      const isLogin = this.$store.state.orderUser.isLogin
      return isSmtSite && !isLogin
    },
    formatSize() {
      if (!this.size) return ''
      const kb = this.size / 1024
      if (kb < 1024) {
        return kb.toFixed(1) + 'KB'
      }
      return (kb / 1024).toFixed(1) + 'MB'
    },
    firstAnalyze() {
      return this.autoAnalyzeFile != '' && this.cacheFile.autoAnalyzeFile.fileUrl == ''
    },
  },
  watch: {
    fileUrl() {
      if (this.cacheFile.uploadFile.fileUrl == '' && this.cacheFile.autoAnalyzeFile.fileUrl == '') {
        // 都不存在的情况下 就是恢复订单了
        this.$nextTick(() => {
          this.cacheFile.uploadFile = { fileName: this.fileName, fileUrl: this.fileUrl }
        })
      }
    },
    fileName(newVal) {
      if (newVal && this.status === 0) {
        this.name = newVal
        this.status = 6
      }
      if (!newVal) {
        this.name = ''
        this.status = 0
      }
    },
    analyzeFile(newVal, oldVal) {
      if (newVal != oldVal) {
        this.autoAnalyzeFile = newVal
        if (oldVal != '' && oldVal != null) {
          // 如果旧地址不是空 非第一次分析
          this.showNewAnalyzeFile = true
        }
      }
    },
    pcbFileAnalyzeStatus(newVal) {
      // 用解析来判断 是否要展示错误提示
      if (newVal == 4 || newVal == 5) {
        this.$nextTick(() => {
          if (this.analyzeFile == '') {
            this.showAnalyzeError = true
          }
        })
      }
    }
  },
  filters: {
    filterFileName(fileName) {
      return fileName.split('/').pop()
    }
  },
  methods: {
    handleEmit(data) {
      this.$emit('input', data)
      this.$emit('change', data)
    },
    handleClick() {
      if (this.isSmtNotLogin) {
        this.handleShowLogin()
        return
      }
      this.$refs.uploadRef.$refs['upload-inner'].handleClick()
    },
    setFile(data) {
      /* 
        setFile是处理 PCB切换时候 bom和坐标文件变化的
        已在华秋下单选择
         - 如果存在文件 就替换自动解析
         - 如果不存在文件 就清空自动解析 和自己上传
        已在华秋下单 -> 华秋定制 或者 自己上传
         - 清空自动解析文件
      */
      const { url, clear } = data
      if (url) {
        // 其他情况都使用自动解析模式
        this.autoAnalyzeFile = url
        this.cacheFile.autoAnalyzeFile = { fileName: url.split('/').pop(), fileUrl: url }
        this.handleToggleMode('parsed')
      } else {
        // 如果选订单的没内容 要全部清空 切换手动上传模式
        this.cacheFile.autoAnalyzeFile = { fileName: '', fileUrl: '' }
        if (clear) {
          // 是否需要清理手动上传文件
          this.cacheFile.uploadFile = { fileName: '', fileUrl: '' }
        }
        if (this.autoAnalyzeFile) {
          this.autoAnalyzeFile = ''
          this.handleToggleMode('manual')
        }
      }
    },
    // 上传校验
    handleBeforeUpload(file) {
      this.authToken = getToken()

      const { name, size } = file
      const limitSize = this.limitSize
      const isLimit = size / 1024 / 1024 < limitSize
      if (isLimit) {
        this.status = 1
        this.upload.progress = 0
        this.analyze.progress = 0
        this.size = size
        this.name = name
      } else {
        this.$message.error(`文件大小不能超过 ${limitSize}MB，请重新上传！`)
      }
      return isLimit
    },
    handleToggleMode(type, status) {
      if (!status) {
        // status 为 true的时候不更新 uploadMode
        this.uploadMode = type
      }
      if (type == 'manual') {
        // 使用上传文件
        this.handleEmit({
          ...this.cacheFile.uploadFile,
        })
      } else if (type == 'parsed'){
        // 使用自动解析文件
        this.handleEmit({
          ...this.cacheFile.autoAnalyzeFile,
        })
      }
    },
    useAutoAnalyzeFile() {
      if (this.isSmtNotLogin) {
        this.handleShowLogin()
        return
      }
      this.showNewAnalyzeFile = false
      this.cacheFile.autoAnalyzeFile = { fileName: this.autoAnalyzeFile.split('/').pop(), fileUrl: this.autoAnalyzeFile }
      this.handleToggleMode('parsed')
    },
    // 上传中
    handleOnProgress(event, file) {
      const toFixed_1 = val => Number(val.toFixed(1))
      // 上传进度条处理
      const percent = toFixed_1(event.percent * 0.95)
      this.upload.progress = Number(percent)
      if (event.percent == 100) {
        this.upload.timer = setInterval(() => {
          if (this.upload.progress < 100) {
            const random = toFixed_1(Math.floor(Math.random() * 10) * 0.1)
            this.upload.progress = Math.min(99.99, toFixed_1(this.upload.progress + random))
          }
        }, 300)
      }
    },
    // 上传成功
    handleOnSuccess(res) {
      const { retCode, result, retMsg } = res
      if (retCode === 0) {
        this.upload.progress = 100
        this.status = 4
        // 这里包含多个参数
        this.cacheFile.uploadFile = { 
          ...result
        }
        // 重新上传文件就不显示bom
        this.isShowBom = false
        this.handleToggleMode('manual')
      } else {
        this.upload.progress = 0
        this.status = 3
        this.errorMsg = retMsg
        // 未登录
        if (retCode == 105008) {
          this.handleShowLogin()
        }
      }
    },
    // 上传失败
    handleOnError() {
      this.upload.progress = 0
      this.status = 3
    },
    // 重置
    handleReset() {
      this.status = 0
      this.name = ''
      this.size = 0
      this.analyze_id = ''
      this.upload = { ...defaultUpload }
      this.analyze = { ...defaultAnalyze }
      this.handleEmit()
    },
    // 失败状态重置
    handleErrorReset() {
      if (this.status == 3) {
        this.handleReset()
      }
    },
    // 线上登录弹框
    handleShowLogin() {
      if (this.$smtLogin) {
        this.$emit('beforeLogin')
        this.$nextTick(() => {
          this.$smtLogin({ isShow: true })
        })
      }
    },
    downloadTemplateUrl() {
      this.$emit('downloadTemplateUrl', this.fileType)
    },
    // 关闭解析错误提示
    handleCloseParseError() {
      this.showAnalyzeError = false
    },
    // 查看解析后的文件
    handleViewParsedFile(useFile) {
      if (useFile) {
        window.open(this.cacheFile.autoAnalyzeFile.fileUrl)
      } else if (this.autoAnalyzeFile) {
        window.open(this.autoAnalyzeFile)
      }
    },
    // 关闭文件已更新提示
    handleCloseFileUpdated() {
      this.showNewAnalyzeFile = false
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';

.upload-container {
  .upload-mode-toggle{
    display: flex;
    align-items: center;
    margin-bottom: 6px;
    width: 330px;
    height: 34px;
    padding: 2px;
    background-color: #f2f3f5;
    &__item{
      font-size: 13px;
      color: #999999;
      cursor: pointer;
      text-align: center;
      transition: color 0.2s;
      // padding: 0 18px;
      &--active{
        color: #15A675;
        font-weight: 500;
        height: 32px;
        background: #ffffff;
        border-radius: 3px;
      }
    }
}
  .buy_bom__upload__analyzing{
    display: flex;
    align-items: center;
    height: 32px;
    background-color: #f5f5f5;
    border-radius: 3px;
    margin-bottom: 6px;
    padding-left: 10px;
    .buy_bom__upload__analyzing__img{
      width: 16px;
      height: 16px;
      margin-right: 6px;
      animation: rotate 1s linear infinite;
    }
    .buy_bom__upload__analyzing__text{
      font-size: 12px;
      color: #666666;
    }
  }
  @keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  .buy_bom__upload__analyz__error{
    display: flex;
    align-items: center;
    height: 32px;
    background-color: #fff2f0;
    border-radius: 3px;
    margin-bottom: 6px;
    padding: 0 10px;
    text-align: left;
    &__icon{
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    &__text{
      flex: 1;
      font-size: 12px;
      color: #ff4d4f;
    }
    &__close{
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
  .buy_bom__upload__analyz__success{
    display: flex;
    align-items: center;
    height: 32px;
    background-color: #f5f5f5;
    border-radius: 3px;
    margin-bottom: 6px;
    padding: 0 10px;
    .buy_bom__upload__analyz__success__img{
      width: 16px;
      height: 16px;
      margin-right: 6px;
    }
    .buy_bom__upload__analyz__success__label{
      font-size: 12px;
      color: #80C26A;
    }
    .buy_bom__upload__analyz__success__name{
      font-size: 12px;
      color: #333333;
    }
    .buy_bom__upload__analyz__success__view{
      font-size: 12px;
      color: #15A675;
      cursor: pointer;
      margin-left: 10px;
    }
    .custom-checkbox{
      width: 100px;
      height: 26px;
      background: #ffffff;
      border: 1px solid #d7d7d7;
      border-radius: 3px;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-left: 5px;
      padding-left: 5px;
      input[type="checkbox"]{
        display: none;
      }
      &__box{
        width: 14px;
        height: 14px;
        border: 1px solid #dcdfe6;
        border-radius: 2px;
        margin-right: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        transition: all 0.2s;
        &::after{
          content: '';
          width: 4px;
          height: 7px;
          border: solid #fff;
          border-width: 0 2px 2px 0;
          transform: rotate(45deg) scale(0);
          transition: all 0.2s;
          margin-top: -1px;
        }
      }
      input[type="checkbox"]:checked + &__box{
        background: #409eff;
        border-color: #409eff;
        &::after{
          transform: rotate(45deg) scale(1);
        }
      }
      &__text{
        font-size: 12px;
        color: #666666;
      }
    }
  }
  .file-updated-banner{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    background-color: #FFFAF2;
    border-radius: 3px;
    margin-top: 4px;
    padding: 0 10px;
    &__left{
      display: flex;
      align-items: center;
    }
    &__icon{
      width: 16px;
      height: 16px;
      margin-right: 8px;
    }
    &__text{
      font-size: 12px;
      color: #AD8C6D;
    }
    &__download{
      font-size: 12px;
      color: #1890ff;
      cursor: pointer;
      margin-left: 8px;
      &:hover{
        text-decoration: underline;
      }
    }
    &__right{
      display: flex;
      align-items: center;
    }
    &__btn{
      height: 28px;
      line-height: 28px;
      padding: 0 12px;
      font-size: 12px;
      color: #ffffff;
      background-color: #E6A23C;
      border: none;
      border-radius: 3px;
      cursor: pointer;
      transition: background-color 0.2s;
      &:hover{
        background-color: #ffac2e;
      }
    }
    &__close{
      width: 12px;
      height: 12px;
      margin-left: 8px;
      cursor: pointer;
    }
  }
}

.upload_handle{
  color: $--form-color-base;
}

.upload ::v-deep {
  .upload_handle{
    color: $--form-color-base;
  }
  .el-upload {
    display: block;
    color: $--color-text-primary;
    &:focus {
      color: $--color-text-primary;
    }
    .el-upload-dragger {
      // padding: 13px 9px 16px;
      padding: 0 !important;
      width: 100%;
      height: auto;
      line-height: 1;
      border-radius: 3px;
      border: 0;
      background: transparent;
      // border-color: $--form-color-base;
      // background-color: $--input-background-color;
    }
  }

  .base-text-button.el-button {
    color: $--color-text-secondary;
    &:hover {
      color: #fff;
    }
  }
  .upload__notStarted {
    .notStarted-content {
      border: 1px dashed $--form-color-base;
      background-color: $--input-background-color;
      border-radius: 3px;
      height: 80px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      > img {
        width: 26px;
        flex-shrink: 0;
        margin-right: 16px;
      }
      .notStarted-text {
        text-align: left;
        > div {
          margin: 7px 0 11px;
        }
      }
    }
    >p {
      font-size: 12px;
      color: $--color-text-placeholder;
    }
    .tips-flex {
      margin-top: 6px;
      display: flex;
      justify-content: space-between;
      .tips-text {
        color: #888888;
      }
      .tips-link {
        color: #999999;
        .tips-link-img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
          background-image: url("~@@/assets/img/common/tip-dowaload.png");
          background-size: 16px;
          background-repeat: no-repeat;
        }
        &:hover {
          color: #666666;
          text-decoration: underline;
          .tips-link-img {
            background-image: url("~@@/assets/img/common/tip-dowaload-hover.png");
          }
        }
      }
    }
  }

  .upload__uploading {
    border: 1px dashed $--form-color-base;
    border-radius: 3px;
    height: 48px;
    text-align: left;
    font-size: 12px;
    padding: 0 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .upload__uploading__name {
      line-height: 16px;
      @include ellipsis;
    }
    .upload__uploading__text {
      margin: 13px 0 8px;
      font-weight: 700;
    }
  }

  .upload__success {
    text-align: left;
    font-size: 12px;
    .upload__success__name {
      line-height: 16px;
      @include ellipsis;
    }
    .upload__success__text {
      margin: 13px 0 8px;
      font-weight: 700;
    }
  }

  .upload__fail {
    .upload__fail__text {
      color: $--color-danger;
    }
    .upload__fail__tips {
      margin: 6px 0 8px;
      font-size: 12px;
      color: $--color-text-disabled;
    }
  }

  .upload__analyze__fail {
    .upload__analyze__fail__text {
      margin: 12px 0 14px;
      color: $--color-danger;
    }
  }
  .parsed-file-wrap{
    display: flex;
    align-items: center;
    .parsed-file-row{
      flex: 1;
      display: flex;
      align-items: center;
      height: 40px;
      background-color: #f7fcfb;
      border: 1px solid #15A675;
      border-radius: 3px;
      padding: 0 12px;
      position: relative;
      &__content{
        display: flex;
        align-items: center;
        flex: 1;
      }
      &__icon{
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      &__name{
        font-size: 12px;
        color: #333333;
      }
      &__size{
        font-size: 12px;
        color: #999999;
        margin-left: auto;
      }
      &__bom {
        font-size: 12px;
        color: #15A675;
        margin-left: auto;
      }
      &__corner{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 16px;
        height: 16px;
      }
    }
    .parsed-file-row__btn{
      height: 32px;
      line-height: 32px;
      width: 96px;
      font-size: 12px;
      text-align: center;
      color: #666666;
      background-color: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 3px;
      cursor: pointer;
      transition: all 0.2s;
      margin-left: 12px;
      flex-shrink: 0;
      &:hover{
        color: #15A675;
        border-color: #15A675;
      }
    }
  }
}

// 使用解析文件样式
.use-parsed-file-wrapper {
  .use-parsed-file-content {
    display: flex;
    align-items: center;
    .use-parsed-file-row {
      flex: 1;
      display: flex;
      align-items: center;
      height: 40px;
      background-color: #f7fcfb;
      border: 1px solid #15A675;
      border-radius: 3px;
      padding: 0 12px;
      position: relative;
      &__content {
        display: flex;
        align-items: center;
        flex: 1;
      }
      &__icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      &__name {
        font-size: 12px;
        color: #333333;
        margin-right: 12px;
      }
      &__tag {
        width: 56px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        color: #E6A23C;
        font-size: 12px;
        background: #fdf6eb;
        border: 1px solid #eab059;
        border-radius: 3px;
        font-size: 12px;
        margin-right: 12px;
      }
      &__download {
        font-size: 12px;
        color: #15A675;
        cursor: pointer;
      }
      &__bom {
        font-size: 12px;
        color: #15A675;
        margin-left: auto;
      }
      &__corner {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 16px;
        height: 16px;
      }
    }
    .use-parsed-file-row__btn {
      height: 32px;
      line-height: 32px;
      width: 96px;
      font-size: 12px;
      text-align: center;
      color: #666666;
      background-color: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 3px;
      cursor: pointer;
      transition: all 0.2s;
      margin-left: 12px;
      flex-shrink: 0;
      &:hover {
        color: #15A675;
        border-color: #15A675;
      }
    }
  }
}

.parsed-file-row.parsed-file-row--fail {
  border: 1px dashed #FFA3A3 !important;
  background-color: #fff3f3!important;
  .parsed-file-row__name {
    color: #555555!important;
  }
}

.parse-error-banner{
  height: 32px;
  border-radius: 3px;
  padding: 0 10px;
  margin-top: 6px;
  text-align: left;
  &__icon{
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  &__text{
    flex: 1;
    font-size: 12px;
    color: #ff4d4f;
  }
}

.upload {
  &.upload--3 ::v-deep,
  &.upload--5 ::v-deep {
    .el-upload-dragger {
      border-color: $--color-danger;
      background-color: #fff;
    }
  }
  &.upload--4 ::v-deep,
  &.upload--6 ::v-deep {
    .el-upload-dragger {
      padding: 8px 16px 13px;
      border-color: $--color-success;
      background-color: #fff;
      overflow: visible;
    }
  }
}

.upload--notLogin {
  position: relative;
  .upload--notLogin__modal {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
}
</style>